<template>
  <div id="transactionReports">
    <template>
      <v-card flat>
        <v-card-text>
          <v-container class="pa-0" v-if="session.role() === 'admin'">
            <v-layout>
              <v-flex class="xs12 mb-5">
                <v-btn fab absolute right title="Sync Transactions" @click="syncTransactionReports" class="ml-3 pf-btn-fab">
                  <v-icon>sync</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
          <v-layout wrap row class="mb-4 mr-4 flex-end">
            <v-flex sm3 class="mb-2 mr-4">
              <div class="text-xs-right">
                <v-btn class="pf-btn pf-bg-teal">
                  <download-excel :data="transactionList" :fields="exportFields" :name="exportExcelName">Export to Excel</download-excel>
                </v-btn>
              </div>
            </v-flex>
            <v-flex sm6 class="pr-2">
              <v-daterange
                ref="dateRange" 
                v-model="dateRange"
                :presets="presets" 
                display-format="MM/dd/yyyy"
                :max="new Date().toISOString().substr(0,10)"
                :input-props="inputProps"
                :show-reset="false"
                @menu-closed="fetchTransactionsByStatus()"
                class="dateRange">
              </v-daterange>
            </v-flex>
          </v-layout>
          <v-card-title class="pl-0 pr-0 pb-0">
            <v-layout wrap row class="mb-4">
              <v-flex sm3 pa-2>
                <v-select
                  class="filter_left pt-0"
                  v-model="currentStatus" 
                  label="Filter by Status"
                  :items="statusListAll"
                  item-key="value"
                  @change="filterByStatus"
                  >
                </v-select>
              </v-flex>
              <v-flex sm6 pa-2 v-if="session.role() === 'admin'">
                <v-select
                  class="filter_left pt-0"
                  v-model="currentAgency" 
                  label="Filter by Agency"
                  :items="agencyList"
                  item-key="value"
                  @change="filterByAgency"
                  >
                </v-select>
              </v-flex>
              <v-flex pl-2 :class="{ sm3: session.role() === 'admin', sm6: session.role() !== 'admin' }">
                <v-text-field
                  v-model="search"
                  append-icon="search"
                  label="Search here"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-title>
          <v-card>
            <v-data-table
              :headers="headers"
              :items="transactionList"
              :search="search"
              no-data-text="No results found"
              :pagination.sync="pagination"
              class="pf-data-table"
            >
              <template v-slot:items="props">
                <tr>
                  <td>{{ formatDate(props.item.submit_date, 'YYYY-MM-DD') }}</td>
                  <td>{{ props.item.subscription ? props.item.subscription.id : '--' }}</td>
                  <td>
                    <template v-if="props.item.subscription && props.item.subscription.name">
                      <a @click="viewPayments(props.item)">{{ props.item.subscription.name }}</a>
                    </template>
                    <template v-else>--</template>
                  </td>
                  <td>{{ props.item.transaction_id }}</td>
                  <!-- <td>{{ props.item.profile && props.item.profile.email ? props.item.profile.email : '--' }}</td> -->
                  <td>{{ statusTexts[props.item.transaction_status] ? statusTexts[props.item.transaction_status] : props.item.transaction_status }}</td>
                  <td>{{ props.item.payment_amount }}</td>
                  <td align="right">
                    <v-flex class="flex-space-between">
                      <v-btn v-if="props.item && props.item.account" icon class="ma-0" @click="changePaymentMethod(props.item)" title="Change payment method">
                        <v-icon size="22" color="grey darken-2">payments</v-icon>
                      </v-btn>
                      <v-btn v-if="props.item && props.item.account && props.item.profile" icon class="ma-0" @click="cancelSubscription(props.item)" title="Cancel Subscription">
                        <v-icon size="22" color="grey darken-2">subscriptions</v-icon>
                      </v-btn>
                    </v-flex>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card>
        </v-card-text>
      </v-card>
    </template>

    <app-modal :active="isViewPayments" v-if="isViewPayments" width="70%">
      <div slot="modal-content">
        <v-card>
          <v-toolbar card dark class="pf-bg-teal">
            <v-btn class="pf-modal-close" icon dark @click="closeViewPayments">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>Subscription Transactions</v-toolbar-title>
          </v-toolbar>

          <v-card-text class="mt-4 mb-4">
            <v-data-table
              :headers="transactionHeaders"
              :items="subscriptionTransactions"
              no-data-text="No transactions found"
              :pagination.sync="transactionsPagination"
              class="pf-data-table"
            >
              <template v-slot:items="props">
                <tr>
                  <td>{{ formatDate(props.item.submit_date, 'YYYY-MM-DD') }}</td>
                  <td>{{ props.item.transaction_id }}</td>
                  <td>{{ props.item.subscription && typeof props.item.subscription.payNum !== 'undefined' ? props.item.subscription.payNum : '--' }}</td>
                  <td>{{ statusTexts[props.item.transaction_status] ? statusTexts[props.item.transaction_status] : props.item.transaction_status }}</td>
                  <td>{{ props.item.payment_amount }}</td>
                  <td v-if="session.role() === 'admin'">
                    <a @click="refundTransaction(props.item)" v-if="props.item.transaction_status === 'settledSuccessfully' && props.item.status === 'Open'">
                      Refund
                    </a>
                    <template v-else-if="props.item.status === 'Refunded'">Refund Done</template>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <!-- <v-btn
              class="pf-btn-text-white pf-bg-teal"
              @click="cancelSubscription()"
              v-if="currentSubscription.account"
            >
              Cancel Subscription
            </v-btn> -->
            <v-btn
              class="pf-btn-text-white pf-bg-pink"
              @click="closeViewPayments"
            >
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </div>
    </app-modal>

    <app-modal :active="showAddCardPopup" v-if="showAddCardPopup" width="30%">
        <div slot="modal-content">
          <v-card>
            <v-toolbar card dark class="pf-bg-teal">
              <v-btn class="pf-modal-close" icon dark @click="closeAddCardPopup">
                <v-icon>close</v-icon>
              </v-btn>
              <v-toolbar-title>Add New Card</v-toolbar-title>
            </v-toolbar>

            <v-card-text class="mt-4 mb-4">
              <v-form ref="newCardForm">
                <v-layout wrap>
                  <!-- Content -->
                  <v-flex xs12>
                    <v-text-field label="Card number" v-model.trim="newCardNumber" :rules="rules.card.number" class="required pr-3 pl-3 flex-center" @input="newCardChange($event)" placeholder="#### #### #### ####" :value="newCard.number" v-mask="'#### #### #### ####'" type="password">
                      <template v-slot:prepend>
                        <v-fade-transition leave-absolute>
                          <div class="pf-card-icon-single" :style="`background-image:url(/static/cards/${newCard.icon});`"></div>
                        </v-fade-transition>
                      </template>
                    </v-text-field>
                    <span v-if="newCardNumberMask" class="pf-pos-relative tm-20 ml-3">Card Number: {{ newCardNumberMask }}</span>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field v-model.trim="newCard.name" :rules="rules.card.name" label="Card holder name" class="required pr-3 pl-3"></v-text-field>
                  </v-flex>
                  <v-flex xs8>
                    <v-text-field v-model.trim="newCard.expiry" :rules="rules.card.expiry" label="Expiry date" class="required pr-3 pl-3" v-mask="'## / ##'" placeholder="MM/YY"></v-text-field>
                  </v-flex>
                  <v-flex xs4>
                    <v-text-field v-model.trim="dummyCvv" :rules="rules.card.cvv" label="CVV" class="required pr-3 pl-3" v-mask="'####'" type="password" placeholder="CVV"></v-text-field>
                  </v-flex>
                </v-layout>
              </v-form>

            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                class="pf-btn-text-white pf-bg-green"
                @click="saveNewCard"
              >
                Add Card
              </v-btn>
              <v-btn
                class="pf-btn-text-white pf-bg-pink"
                @click="closeAddCardPopup"
              >
                Cancel
              </v-btn>
            </v-card-actions>
          </v-card>
        </div>
      </app-modal>

      <app-modal :active="isChangePaymentMethod" v-if="isChangePaymentMethod" width="40%">
        <div slot="modal-content">
          <v-card>
            <v-toolbar card dark class="pf-bg-teal">
              <v-btn class="pf-modal-close" icon dark @click="closeChangePaymentMethod">
                <v-icon>close</v-icon>
              </v-btn>
              <v-toolbar-title>Change Payment Method</v-toolbar-title>
            </v-toolbar>

            <v-card-text class="mt-1 mb-2 pa-4">
              <p class="pf-text-default">Choose your saved cards or add a new one.</p>
              <!-- List cards -->
              <v-layout>
                <v-flex class="flex-column">
                  <v-radio-group v-model="selectedCardId" @change="{}" return-object>
                    <p class="ml-2" v-if="currentTransaction && currentTransaction.profile && currentTransaction.profile.paymentProfile.payment && currentTransaction.profile.paymentProfile.payment.creditCard">{{ currentTransaction.profile.paymentProfile.payment.creditCard.cardNumber }} <small>(selected)</small></p>
                    <p v-else-if="!cards.length">No saved cards found.</p>
                    
                    <v-layout v-for="(card, i) in cards" :key="i">
                      <v-flex class="flex-center">
                        <v-radio
                          :value="card.id"
                          class="flex-center"
                        >
                          <template v-slot:label>
                            <div class="flex-center">
                              <div class="pf-card-icon" :style="`background-image:url(/static/cards/${card.icon});`"></div>
                              #### #### #### {{ card.number.substr(card.number.length - 4) }}
                            </div>
                          </template>
                        </v-radio>
                      </v-flex>
                    </v-layout>
                  </v-radio-group>
                  <v-btn class="pf-btn pf-btn-save pf-width-50p" @click="addNewCard">
                    <v-icon size="16" class="pr-1">add</v-icon>
                    <div>Add New Card</div>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                class="pf-btn-text-white pf-bg-green"
                @click="saveNewPaymentMethod"
                :disabled="!selectedCardId"
              >
                Submit
              </v-btn>
              <v-btn
                class="pf-btn-text-white pf-bg-pink"
                @click="closeChangePaymentMethod"
              >
                Cancel
              </v-btn>
            </v-card-actions>
          </v-card>
        </div>
      </app-modal>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
/* global session store config moment */
import swal from 'sweetalert2';
import { request, formatDate, getCollection, getCardType, create } from '../../helpers/helpers';
import appView from '../Invoices/view';
import { VDaterange } from 'vuetify-daterange-picker';
import 'vuetify-daterange-picker/dist/vuetify-daterange-picker.css';
import JsonExcel from 'vue-json-excel';
import moment from 'moment';
moment.tz.setDefault(config.timezone);
import AppModal from '../../components/AppModal.vue';
import { mask } from 'vue-the-mask';
const sleep = (milliseconds) => {
  return new Promise(resolve => setTimeout(resolve, milliseconds));
};

export default {
  name: 'Invoices',
  components: {
    appView,
    VDaterange,
    'downloadExcel': JsonExcel,
    'app-modal': AppModal
  },
  directives: { mask },
  data: (vm) => ({
    config: config,
    transactionList: [],
    countByStatus: [],
    currentStatus: 'All',
    isViewPayments: false,
    subscriptionTransactions: [],
    currentSubscription: null,
    statusTexts: {
      settledSuccessfully: 'Success Transaction',
      voided: 'Voided Transaction',
      expired: 'Expired',
      declined: 'Declined',
      pendingFinalSettlement: 'Pending',
      generalError: 'General Error',
      communicationError: 'Communication Error',
      refundSettledSuccessfully: 'Refund Success',
    },
    statusListAll: [
      { value: 'All', text: 'All' },
      { value: 'settledSuccessfully', text: 'Success Transactions' },
      { value: 'voided', text: 'Voided Transactions' },
      { value: 'expired', text: 'Expired' },
      { value: 'declined', text: 'Declined' },
      { value: 'pendingFinalSettlement', text: 'Pending' },
      { value: 'generalError', text: 'General Error' },
      { value: 'communicationError', text: 'Communication Error' },
      { value: 'refundSettledSuccessfully', text: 'Refund Success' }
    ],
    selectDate: 'Last Month',
    dateFilterList: ['Last Month'],
    search: '',
    headers: [
      { text: 'Date', value: 'submit_date', align: 'left' },
      { text: 'Subscr ID', value: 'subscription.id', align: 'left' },
      { text: 'Subscr Name', value: 'subscription.name' },
      { text: 'Trans ID', value: 'transaction_id' },
      // { text: 'Email', value: 'profile.email' },
      { text: 'Status', value: 'transaction_status' },
      // { text: 'Customer', value: 'customer' },
      { text: 'Amount', value: 'payment_amount' },
      { text: 'Actions', sortable: false }
    ],
    transactionHeaders: [
      { text: 'Date', value: 'submit_date', align: 'left' },
      { text: 'Trans ID', value: 'transaction_id' },
      { text: 'Payment', value: 'subscription.payNum' },
      { text: 'Status', value: 'transaction_status' },
      { text: 'Amount', value: 'payment_amount' }
    ],
    transactionsPagination: {
      rowsPerPage: config.dom.rowsPerPage,
      sortBy: 'submit_date',
      descending: false
    },
    pagination: {
      rowsPerPage: config.dom.rowsPerPage,
      sortBy: 'submit_date',
      descending: false
    },
    dateRange: { 
      // start: moment().startOf('month').format('YYYY-MM-DD'),
      // end: moment().format('YYYY-MM-DD')
    },
    presets: [
      {
        label: 'Today',
        range: [
          moment().startOf('day').format('YYYY-MM-DD'),
          moment().endOf('day').format('YYYY-MM-DD'),
        ],
      },
      {
        label: 'Yesterday',
        range: [
          moment().add(-1, 'days').format('YYYY-MM-DD'),
          moment().add(-1, 'days').endOf('day').format('YYYY-MM-DD')
        ]
      },
      {
        label: 'This Week',
        range: [
          moment().startOf('week').format('YYYY-MM-DD'),
          moment().endOf('week').format('YYYY-MM-DD')
        ]
      },
      {
        label: 'Last 7 days',
        range: [
          moment().add(-7, 'days').format('YYYY-MM-DD'),
          new Date().toISOString().substr(0, 10)
        ]
      },
      {
        label: 'Last 15 days',
        range: [
          moment().add(-15, 'days').format('YYYY-MM-DD'),
          new Date().toISOString().substr(0, 10)
        ]
      },
      {
        label: 'This Month',
        range: [
          moment().startOf('month').format('YYYY-MM-DD'),
          new Date().toISOString().substr(0, 10)
        ]
      },
      {
        label: 'Last Month',
        range: [
          moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD'),
          moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD')
        ]
      },
      {
        label: 'Last 3 Month',
        range: [
          moment().subtract(3, 'month').startOf('month').format('YYYY-MM-DD'),
          moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD')
        ]
      },
    ],
    inputProps: {
      'prepend-icon': 'event',
      'label': 'Date Range'
    },
    exportFields: {
      'Submit Date': {
        callback: (value) => {
          return formatDate(value.submit_date, 'YYYY-MM-DD');
        }
      },
      'Subscr ID': {
        callback: (value) => {
          return value.subscription ? value.subscription.id : '--';
        }
      },
      'Subscr Name': {
        callback: (value) => {
          return value.subscription && value.subscription.name ? value.subscription.name : '--';
        }
      },
      'Payment': {
        callback: (value) => {
          return value.subscription ? value.subscription.payNum : '--';
        }
      },
      'Trans ID': {
        callback: (value) => {
          return value.transaction_id;
        }
      },
      'PPN': {
        callback: (value) => {
          return value.profile && value.profile.ppn ? value.profile.ppn : '--';
        }
      },
      'Email': {
        callback: (value) => {
          return value.profile && value.profile.email ? value.profile.email : '--';
        }
      },
      'Trans Status': {
        callback: (value) => {
          return vm.statusTexts[value.transaction_status] ? vm.statusTexts[value.transaction_status] : value.transaction_status;
        }
      },
      'Customer': {
        callback: (value) => {
          return value.customer;
        }
      },
      'Payment Amount': {
        callback: (value) => {
          return value.payment_amount;
        }
      }
    },
    rules: {
      card: {
        // number: [v => !!v || 'Card number is required'],
        number: [
          // v => Number.isInteger(v) || 'Please enter an integer',
          // v => v.length <= 16 || 'Card number should not exceed 16 digits'
        ],
        name: [v => !!v || 'Card holder name is required'],
        cvv: [v => !!v || 'CVV is required'],
        expiry: [
          v => !!v || 'Card expiry is required',
          v => vm.validateDateChange(v) || 'Date is invalid or card expired'
        ],
      },
      ppn: [
        v => !!v || 'PPN is required',
        v => v.indexOf('_') > -1 && v.split('_').length === 2 || 'Please enter a valid PPN'
      ]
    },
    isChangePaymentMethod: false,
    newCard: {
      name: '',
      number: '',
      expiry: '',
      icon: 'credit-card.ico',
      type: ''
    },
    showAddCardPopup: false,
    dummyCvv: '',
    newCardNumber: '',
    newCardNumberMask: '',
    cardIcons: [
      { type: 'Visa', icon: 'visa.png' },
      { type: 'Mastercard', icon: 'mastercard.png' },
      { type: 'American Express', icon: 'amex.png' },
      { type: 'Diners Club', icon: 'diners-club.png' },
      { type: 'Discover', icon: 'discover.jpg' },
      { type: 'JCB', icon: 'jcb.png' },
      { type: 'Unknown', icon: 'credit-card.ico' }
    ],
    cards: [],
    selectedCardId: null,
    currentTransaction: null
  }),
  computed: {
    ...mapGetters([]),
    exportExcelName () {
      return 'PF_Transaction_Report_' + moment().tz(config.timezone).format('MM_DD_YYYY');
    },
    AuthorizeTransactionReport: {
      set (value) {
        store.commit('setAuthorizeTransactionReport', value);
      },
      get () {
        return store.state.AuthorizeTransactionReport;
      }
    },
    PaymentMode: {
      get () {
        return store.state.PaymentMode;
      },
      set (value) {
        store.commit('setPaymentMode', value);
      }
    },
    Account: {
      get () {
        return store.state.Account;
      },
      set (value) {
        store.commit('setAccount', value);
      }
    },
  },
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  async created () {
    await this.fetchTransactionsByStatus(true);
  },
  methods: {
    async fetchTransactionsByStatus (initialLoad = false) {

      this.AuthorizeTransactionReport = {};

      let where = {
        account: this.Account.id
      };
      if (!initialLoad && this.dateRange && this.dateRange.start && this.dateRange.end) {
        where.submit_date = {
          '$gte': new Date(this.dateRange.start),
          '$lte': new Date(this.dateRange.end)
        };
      }
      if (this.currentStatus !== 'All') {
        where.transaction_status = this.currentStatus;
      }
      let populate = [{ path: 'agency', select: 'name' }];
      
      let { error, data } = await getCollection('AuthorizeNetTransactionReport', true, 0, populate, where, null, null, { 'submit_date': 'asc' });

      if (error) {
        console.log(error);
        swal.fire({
          type: 'warning',
          title: 'Failed to Fetch',
          text: `Failed to fetch the transactions, please tray again.`,
          showConfirmButton: true,
          onClose: () => {}
        });
      } else {
        this.transactionList = data;
        this.AuthorizeTransactionReport[this.currentStatus] = data;
        this.AuthorizeTransactionReport = this.AuthorizeTransactionReport;
      }
    },
    async fetchPaymentModes (item) {
      if (item && item.account && item.profile && item.profile.customerProfileId) {
        let where = { account: item.account, customer_profile_id: item.profile.customerProfileId };
        let { error, data } = await getCollection('PaymentMode', true, 0, '', where);
        if (error) {
          console.log(error);
        } else {
          this.PaymentMode = data;
          /* Set the local card variable */
          this.setCards();
        }
      } else {
        this.setCards();
      }
    },
    setCards () {
      this.cards = this.PaymentMode.map(mode => {
        mode.card.icon = 'credit-card.ico';
        mode.card.id = mode.id;
        return mode.card;
      });
    },
    async changePaymentMethod (item) {
      if (!item || !item.account) {
        return false;
      }
      if (!item.profile || !item.profile.customerProfileId) {
        swal.fire({
          type: 'warning',
          title: 'Warning',
          text: `The AuthorizeNet customer profile not found.`,
          showConfirmButton: true,
          onClose: () => {}
        });
        return false;
      }
      if (!item.subscription) {
        swal.fire({
          type: 'warning',
          title: 'Warning',
          text: `The AuthorizeNet payment subscription id not found.`,
          showConfirmButton: true,
          onClose: () => {}
        });
        return false;
      }
      /* Fetch the payment modes - Cards */
      await this.fetchPaymentModes(item);
  
      /* Set the card icon based on card type */
      this.setCardIcons();

      this.currentTransaction = item;
      this.isChangePaymentMethod = true;
    },
    setCardIcons () {
      this.cards = this.cards.map((x) => {
        let index = this.cardIcons.findIndex(y => y.type === x.type);
        if (x.type && index > -1) {
          x.icon = this.cardIcons[index].icon;
        }
        return x;
      });
    },
    closeChangePaymentMethod (clearCurrentTransaction = true) {
      if (clearCurrentTransaction) {
        this.currentTransaction = null;
      }
      this.isChangePaymentMethod = false;
    },
    addNewCard () {
      /* Close the popup if requested from settings */
      if (this.isChangePaymentMethod) {
        this.closeChangePaymentMethod(false);
      }
      this.showAddCardPopup = true;
      this.dummyCvv = '';
    },
    closeAddCardPopup () {
      this.currentTransaction = null;
      this.showAddCardPopup = false;
      this.newCardNumber = '';
      this.newCardNumberMask = '';
      this.newCard = {
        name: '',
        number: '',
        expiry: '',
        icon: 'credit-card.ico',
        type: ''
      };
      /* Open the change payment method popup if request comes from there */
      if (!this.isOverviewActive) {
        this.changePaymentMethod();
      }
    },
    newCardChange (newValue) {
      this.newCard.number = newValue.replace(/ /g, '');
      if (this.newCard.number && this.newCard.number.trim() && this.newCard.number.replace(' ', '')) {
        let cardType = getCardType(this.newCard.number.replace(' ', ''));
        let index = this.cardIcons.findIndex(y => y.type === cardType);
        if (index > -1) {
          this.newCard.icon = this.cardIcons[index].icon;
          this.newCard.type = cardType;
        }
      }
      this.newCardNumberMask = this.newCard.number.replace(' ', '').replace(/.(?=.{4})/g, '#').match(/.{1,4}/g).join(' ');
    },
    async saveNewCard () {
      if (this.$refs.newCardForm.validate() && this.currentTransaction && this.currentTransaction.account) {
        if (this.newCard) {
          let payload = { card: JSON.parse(JSON.stringify(this.newCard)) };
          delete payload.card.icon;
          /* format the card number and expiry */
          payload.card.number = payload.card.number.replace(/ /g, '');
          payload.card.expiry = payload.card.expiry.replace(' / ', '');
          payload.card.type = payload.card.type ? payload.card.type : 'Unknown';
          payload.account = this.currentTransaction.account;
          payload.customer_profile_id = this.currentTransaction.profile.customerProfileId;
          let { error, data } = await create('PaymentMode', payload);
          if (error) {
            console.log(error);
            swal.fire({
              type: 'warning',
              title: 'Error',
              text: `${error.message || error}. If problem persists please contact support at support@parentfinder.com`,
              showConfirmButton: true,
              onClose: () => {
                this.newCard = {
                  name: '',
                  number: '',
                  expiry: '',
                  icon: 'credit-card.ico',
                  type: ''
                };
              }
            });
          } else if (data) {
            this.PaymentMode.push(data);
            this.setCards();
            this.setCardIcons();
            
            /* let cardType = getCardType(data.card.number);
            let index = this.cardIcons.findIndex(y => y.type === cardType);
            let icon = 'credit-card.ico';
            if (cardType && index > -1) {
              icon = this.cardIcons[index].icon;
            } */
            this.newCard = {
              name: '',
              number: '',
              expiry: '',
              icon: 'credit-card.ico',
              type: ''
            };
            this.showAddCardPopup = false;
            
            /* Ask the user if the new card should be selected as the payment method */
            swal.fire({
              title: 'Set Payment Method?',
              text: 'Your card was added successfully, do you want to set this new card as your default payment method?',
              type: 'success',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Yes, I do!',
              cancelButtonText: 'No'
            }).then(async (result) => {
              if (result.value) {
                this.selectedCardId = data.id;
                /* Sleep for 2 seconds */
                await sleep(2000);
                /* Call the change payment method API */
                await this.saveNewPaymentMethod();
                this.currentTransaction = null;
              } else {
                /* Open the change payment method popup again */
                this.isChangePaymentMethod = true;
              }
            });
          }
        }
      }
    },
    async saveNewPaymentMethod () {
      let index = this.cards.findIndex(x => x.id === this.selectedCardId);
      if (this.selectedCardId && index > -1 && this.currentTransaction && this.currentTransaction.profile && this.currentTransaction.subscription) {
        let payload = {
          authorize_profile_id: this.currentTransaction.profile.customerProfileId.toString(),
          subscription_id: this.currentTransaction.subscription.id.toString(),
          payment_mode: this.selectedCardId,
          request_from: 'TransactionReport'
        };
        let { error, data } = await request('PaymentSubscription/UpdatePaymentMode', 'PUT', payload);
        if (error) {
          console.log(error);
          swal.fire({
            type: 'warning',
            title: 'Error',
            text: `${error.message || error}. If problem persists please contact support at support@parentfinder.com`,
            showConfirmButton: true,
            onClose: () => {
              // 
            }
          });
        } else {
          this.closeChangePaymentMethod();
          
          let transactionIndex = this.transactionList.findIndex(x => x._id.toString() === this.currentTransaction._id.toString());
          if (transactionIndex > -1) {
            this.currentTransaction.profile.paymentProfile = data.payment_profile_id;
            this.transactionList[transactionIndex].profile.paymentProfile = data.payment_profile_id;
            this.transactionList[transactionIndex].profile.paymentProfile.payment.creditCard = {
              cardNumber: data.card.number,
              expirationDate: data.card.expiry
            };
            this.transactionList = this.transactionList;
          }

          swal.fire({
            type: 'success',
            title: 'Your payment method was changed successfully',
            showConfirmButton: false,
            timer: 2500,
            onClose: () => {
              // 
            }
          });
        }
      }
    },
    validateDateChange (value) {
      if (value && value.trim()) {
        let splited = this.newCard.expiry.trim().split(' / ');
        if (parseInt(splited[0], 10) > 12 || parseInt(splited[0], 10) < 1) {
          return false;
        }
        let currentYear = (new Date()).getFullYear();
        let currentMonth = (new Date()).getMonth() + 1;
        let lastTwo = currentYear.toString().substr(2);
        if (parseInt(splited[1], 10) < lastTwo || (parseInt(splited[1], 10) === lastTwo && currentMonth)) {
          return false;
        }
      }
      return true;
    },
    formatPrice (value) {
      if (value) {
        let val = Number((value).toFixed(2)).toLocaleString();
        return val.indexOf('.') > -1 ? val : (val + '.00');
      }
    },
    async viewPayments (item) {
      /* Fetch the subscrition payments */
      if (item && item.subscription && item.subscription.id) {
        this.currentSubscription = item;
        let where = {
          'subscription.id': item.subscription.id
        };
        let { error, data } = await getCollection('AuthorizeNetTransactionReport', true, 0, '', where);
        if (error) {
          console.log(error);
          swal.fire({
            type: 'warning',
            title: 'Failed to Fetch',
            text: `Failed to fetch the transactions, please tray again.`,
            showConfirmButton: true,
            onClose: () => {}
          });
        } else {
          this.subscriptionTransactions = data;
        }
        this.isViewPayments = true;
      }
    },
    closeViewPayments () {
      this.isViewPayments = false;
      this.subscriptionTransactions = [];
      this.currentSubscription = null;
    },
    async filterByStatus () {

      if (this.currentStatus && this.AuthorizeTransactionReport[this.currentStatus]) {
        this.transactionList = this.AuthorizeTransactionReport[this.currentStatus];
      } else {
        await this.fetchTransactionsByStatus();
      }
    },
    // cancelSubscription (item = null) {
    //   if (item) {
    //     this.currentSubscription = item;
    //   }
    //   swal.fire({
    //     title: 'Are you sure?',
    //     text: 'Are you sure that you want to cancel this subscription?',
    //     type: 'warning',
    //     showCancelButton: true,
    //     confirmButtonColor: '#3085d6',
    //     cancelButtonColor: '#d33',
    //     confirmButtonText: 'Yes, cancel it!'
    //   }).then(async (result) => {
    //     if (result.value) {
    //       (async () => {
    //         let payload = {
    //           account: this.currentSubscription.account,
    //           subscription_type: 'Membership',
    //           subscription_id: this.currentSubscription.subscription.id
    //         };
    //         let { error, data } = await request('PaymentSubscription/Cancel', 'PUT', payload);
    //         if (error) {
    //           console.log('error', error);
    //           swal.fire({
    //             type: 'warning',
    //             title: 'Error',
    //             text: typeof error === 'string' ? error : (error.message || 'Something went wrong, please check with your agency'),
    //             showConfirmButton: true,
    //             onClose: () => {}
    //           });
    //           return;
    //         } else {
    //           /* Update the UI */
    //           swal.fire({
    //             type: 'success',
    //             title: 'Success',
    //             text: 'The subscription was cancelled successfully',
    //             showConfirmButton: false,
    //             timer: 2500,
    //             onClose: () => {
    //               // 
    //             }
    //           });
    //         }
    //       })();
    //     }
    //     this.currentSubscription = null;
    //   });
    // },
    formatDate (dateString) {
      if (dateString) {
        return formatDate(dateString, 'MM/DD/YYYY');
      }
    }
  }
};
</script>
<style scoped lang="css">
#billing >>> .v-select__selection {
    width: 100%;
    justify-content: center;
    padding-left: 20px;
}

#billing >>> .accent--text {
    color: #019d8c !important;
    caret-color: #019d8c !important;
}

.theme--dark.v-btn.v-btn--disabled:not(.v-btn--icon):not(.v-btn--flat):not(.v-btn--outline) {
  background-color: lightgray !important;
  color: #fff !important;
}

.dateRange >>> .v-menu {
    width: 100% !important;
}
.v-tabs__item:not(.v-tabs__item--active) {
  background: #019d8c;
  color: #fff;
}

</style>



// WEBPACK FOOTER //
// src/pages/Reports/AuthorizeNetTransactionsParent.vue